import { c as _c } from "react/compiler-runtime";
export const SummaryStatisticsTableCell = t0 => {
  const $ = _c(4);
  const {
    label,
    value,
    isLoading: t1
  } = t0;
  const isLoading = t1 === undefined ? false : t1;
  let t2;
  if ($[0] !== isLoading || $[1] !== label || $[2] !== value) {
    t2 = <div className="bg-background-secondary flex flex-col justify-between gap-2 rounded-lg p-3 sm:flex-row sm:gap-0 md:p-6">{isLoading ? <div className="bg-skeleton-primary w-full rounded-sm text-transparent">.</div> : <><span className="text-text-primary font-inter text-start truncate text-[17px] text-lg font-semibold">{label}</span><span className="text-brand-primary text-sm font-semibold sm:text-xl">{value}</span></>}</div>;
    $[0] = isLoading;
    $[1] = label;
    $[2] = value;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
};